import { css } from '@emotion/react';
import Card from '@components/display/card';
import { ProjectType } from '@types';

type CardsPropsType = {
  cards: ProjectType[]
  onProjectClick: (project: ProjectType) => void
};
const Cards = ({ cards, onProjectClick }: CardsPropsType) => {
  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        width: 100%;
        gap: 16px;
      `}
    >
      {cards.map((card) => (
        <Card
          key={`${card.idProject}${card.isReviewProject ? '-review' : ''}`}
          card={card}
          onClick={() => onProjectClick(card)}
          style={{
            width: '100%',
            backgroundColor: card.isAccessibleToUser ? 'white' : 'lightgray',
            cursor: card.isAccessibleToUser ? 'pointer' : 'not-allowed',
            pointerEvents: card.isAccessibleToUser ? 'auto' : 'none',
          }}
        />
      ))}
    </div>
  );
};

export default Cards;
